// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwTextbox from 'viewmodel/AwTextboxViewModel';
import AwBreak from 'viewmodel/AwBreakViewModel';
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { AwClass } from 'js/hocCollection';
const AwButtonAwClass = AwClass(AwButton);
AwButtonAwClass.displayName = 'AwButtonAwClass';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "name": {
      "displayName": "{{i18n.name}}",
      "dbValue": "",
      "type": "STRING",
      "isRequired": "true",
      "isEditable": "true",
      "maxLength": 32,
      "requiredText": "{{i18n.projectNameRequired}}",
      "validationCriteria": [{
        "condition": "conditions.invalidProjectName",
        "value": "{{i18n.invalidProjectName}}"
      }]
    },
    "description": {
      "displayName": "{{i18n.description}}",
      "type": "STRING",
      "isEditable": "true",
      "maxLength": 256,
      "numberOfLines": 3,
      "requiredText": "{{i18n.projectDescriptionOptional}}"
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "actions": {
    "createProject": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation CreateProject( $collaborationspaceId: String, $createProjectInput: CreateProjectInput) { createProject( collaborationspaceId: $collaborationspaceId, createProjectInput: $createProjectInput ) }",
            "variables": {
              "collaborationspaceId": "{{props.collaborationspaceid}}",
              "createProjectInput": {
                "name": "{{data.name.dbValue}}",
                "description": "{{data.description.dbValue}}"
              }
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{props.accsessionid}}"
      },
      "outputData": {
        "errorCode": "errorCode",
        "projectCreated": "data.data.createProject"
      },
      "events": {
        "success": [{
          "condition": "projectCreated.projectId",
          "name": "createProject.success",
          "eventData": {
            "projectCreated": "{{projectCreated}}"
          }
        }, {
          "condition": "projectCreated.error === 'EMPTY_COLLAB_SPACE'",
          "name": "createProject.failure",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectCreated.error.statusCode === 400 || errorCode === 400",
          "name": "createProject.failure",
          "eventData": {
            "error": "{{i18n.BAD_REQUEST_CREATE_PROJECT}}",
            "errorCode": 400
          }
        }, {
          "condition": "projectCreated.error.statusCode === 403 || errorCode === 403",
          "name": "createProject.failure",
          "eventData": {
            "error": "{{i18n.FORBIDDEN_CREATE_PROJECT}}",
            "errorCode": 403
          }
        }, {
          "condition": "projectCreated.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "createProject.failure",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "projectCreated.error.statusCode >= 500 && projectCreated.error.statusCode <= 599",
          "name": "projectCreated.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "createProject.failure",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "createProject.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-project.createdObject",
      "eventData": "{{eventData.projectCreated}}"
    }
  }, {
    "eventId": "createProject.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-project.created-object",
      "eventData": "{{eventData.projectCreated}}"
    }
  }, {
    "eventId": "createProject.failure",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-create-project.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "lifecycleHooks": {
    "onMount": ""
  },
  "conditions": {
    "validInput": {
      "expression": "data.name.dbValue && !conditions.invalidProjectName"
    },
    "invalidProjectName": {
      "expression": "!(/^[a-zA-Z\\d-_ ]+$/.test(data.name.dbValue))"
    }
  },
  "i18n": {
    "Create": ["projectMessages"],
    "name": ["projectMessages"],
    "description": ["projectMessages"],
    "projectNameRequired": ["projectMessages"],
    "projectDescriptionOptional": ["projectMessages"],
    "invalidProjectName": ["projectMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "BAD_REQUEST_CREATE_PROJECT": ["errorMessages"],
    "FORBIDDEN_CREATE_PROJECT": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "CreateProject",
  "_uniqueViewModelId": "CreateProject",
  "ctx": {}
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <aw-textbox prop="data.name"></aw-textbox>
    <aw-break></aw-break>
    <aw-textarea prop="data.description"></aw-textarea>
    <aw-button aw-class="{'disabled': !conditions.validInput}" action="createProject" size="auto">{{i18n.Create}}</aw-button>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement(AwTextbox, getField("data.name", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwBreak, null), /*#__PURE__*/React.createElement(AwTextarea, getField("data.description", fields, $index, null, null)), /*#__PURE__*/React.createElement(AwButtonAwClass, {
    action: actions.createProject,
    size: "auto",
    awClass: AwParseService.instance("{'disabled': !conditions.validInput}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, AwParseService.instance("i18n.Create")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;